// src/actions/orderActions.js
import apiConfig from '../../service/ApiConfig';
import delievryStatus from '../../helper/orderStatus'
export const FETCH_ORDER_REQUEST = 'FETCH_ORDER_REQUEST';
export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';
export const FETCH_ORDER_FAILURE = 'FETCH_ORDER_FAILURE';

export const FETCH_DRIVER_REQUEST = 'FETCH_ORDER_REQUEST';
export const FETCH_DRIVER_SUCCESS = 'FETCH_DRIVER_SUCCESS';
export const FETCH_DRIVER_FAILURE = 'FETCH_DRIVER_FAILURE';

export const FETCH_PAYMENT_VERIFY_REQUEST = 'FETCH_PAYMENT_VERIFY_REQUEST';
export const FETCH_PAYMENT_VERIFY_SUCCESS = 'FETCH_PAYMENT_VERIFY_SUCCESS';
export const FETCH_PAYMENT_VERIFY_FAILURE = 'FETCH_PAYMENT_VERIFY_FAILURE';

export const FETCH_PAYMENT_CREATION_REQUEST = 'FETCH_PAYMENT_CREATION_REQUEST';
export const FETCH_PAYMENT_CREATION_SUCCESS = 'FETCH_PAYMENT_CREATION_SUCCESS';
export const FETCH_PAYMENT_CREATION_FAILURE = 'FETCH_PAYMENT_CREATION_FAILURE';

const defaultUrl = "https://aseertimedelivery.com";
let BaseUrl = defaultUrl;
if (window._env_ && window._env_.API_URL && window._env_.API_URL !== "${API_URL}" && window._env_.API_URL !== "") {
  BaseUrl = window._env_.API_URL.replace(/\/$/, '');
}
// const BaseUrl = "http://localhost:40015";


export const fetchOrderRequest = () => ({
  type: FETCH_ORDER_REQUEST,
});

export const fetchOrderSuccess = (order) => ({
  type: FETCH_ORDER_SUCCESS,
  payload: order,
});

export const fetchOrderFailure = (error) => ({
  type: FETCH_ORDER_FAILURE,
  payload: error,
});


export const fetchDriverRequest = () => ({
  type: FETCH_DRIVER_REQUEST,
});

export const fetchDriverSuccess = (driver) => ({
  type: FETCH_DRIVER_SUCCESS,
  payload: driver,
});

export const fetchDriverFailure = (error) => ({
  type: FETCH_DRIVER_FAILURE,
  payload: error,
});


export const fetchPaymentVerifyRequest = () => ({
  type: FETCH_PAYMENT_VERIFY_REQUEST,
});

export const fetchPaymentVerifySuccess = (order) => ({
  type: FETCH_PAYMENT_VERIFY_SUCCESS,
  payload: order,
});

export const fetchPaymentVerifyFailure = (error) => ({
  type: FETCH_PAYMENT_VERIFY_FAILURE,
  payload: error,
});


export const fetchPaymentCreationRequest = () => ({
  type: FETCH_PAYMENT_CREATION_REQUEST,
});

export const fetchPaymentCreationSuccess = (order) => ({
  type: FETCH_PAYMENT_CREATION_SUCCESS,
  payload: order,
});

export const fetchPaymentCreationFailure = (error) => ({
  type: FETCH_PAYMENT_CREATION_FAILURE,
  payload: error,
});

export const fetchOrder = (orderId) => async (dispatch) => {
  dispatch(fetchOrderRequest());

  // --- MOCK API FOR DEMO ---
  if (orderId === '68d28341a5100512e24792d8' || orderId === 'mock') {
    const mockOrder = {
      id: orderId,
      deliveryStatusId: delievryStatus.STARTED_TRACKING,
      driverId: 'driver123',
      totalAmount: 15.50,
      paymentMethod: 'KNET',
      paymentMethodId: 10,
      promisedDeliveryDateUtc: new Date().toISOString(),
      pickedTime: new Date().toISOString(),
      ETA: '15 mins',
      customerFirstName: 'John',
      customerLastName: 'Doe',
      customerMobileNo: '+965 1234 5678',
      client: { nameEn: 'Aseer Time' },
      customerAddress: {
        addressLine1: 'Block 1, Street 2, House 3',
        latitudeStr: '29.3759',
        longitudeStr: '47.9774'
      },
      clientLocation: {
        locationAddress: {
          addressLine1: 'Aseer Time Main Branch',
          latitudeStr: '29.3780',
          longitudeStr: '47.9820'
        }
      },
      driver: {
        firstName: 'Ali',
        lastName: 'Ahmed',
        mobile: '+965 8765 4321',
      }
    };
    
    setTimeout(() => {
      dispatch(fetchOrderSuccess(mockOrder));
      dispatch(fetchDriver('driver123'));
    }, 1000);
    return;
  }
  // -------------------------

  try {
    const response = await apiConfig.get(`${BaseUrl}/order/${orderId}`);
    dispatch(fetchOrderSuccess(response.data));
    if(response.data.deliveryStatusId == delievryStatus.STARTED_TRACKING || 
      response.data.deliveryStatusId == delievryStatus.PICKED ||
      response.data.deliveryStatusId == delievryStatus.REACHED_CUSTOMER
    ){
    dispatch(fetchDriver(response.data.driverId));
    }
  } catch (error) {
    dispatch(fetchOrderFailure(error.message));
  }
};

export const fetchDriver = (driverId) => async (dispatch) => {
  dispatch(fetchDriverRequest());

  // --- MOCK API FOR DEMO ---
  if (driverId === 'driver123') {
    let currentLat = 29.3780;
    let currentLng = 47.9820;

    const mockDriver = () => ({
      id: 'driver123',
      firstName: 'Ali',
      lastName: 'Ahmed',
      mobile: '+965 8765 4321',
      latitudeStr: currentLat.toString(),
      longitudeStr: currentLng.toString()
    });

    setTimeout(() => {
      dispatch(fetchDriverSuccess(mockDriver()));
    }, 500);

    // Simulate driver movement every 3 seconds
    setInterval(() => {
      currentLat -= 0.0001; // Moving south
      currentLng -= 0.0001; // Moving west
      dispatch(fetchDriverSuccess(mockDriver()));
    }, 3000);

    return;
  }
  // -------------------------

  try {
    const response = await apiConfig.get(`${BaseUrl}/driver/${driverId}`);
    dispatch(fetchDriverSuccess(response.data));
  } catch (error) {
    dispatch(fetchDriverFailure(error.message));
  }
};

export const createPayment = (model) => async (dispatch) => {
  dispatch(fetchPaymentVerifyRequest());
  try {
    const response = await apiConfig.put(`${BaseUrl}/order/paymentlink`,model);
    dispatch(fetchPaymentVerifySuccess(response.data));
  } catch (error) {
    dispatch(fetchPaymentVerifyFailure(error.message));
  }
};

export const verifyPayment = (paymentId) => async (dispatch) => {
  dispatch(fetchPaymentVerifyRequest());
  try {
    const response = await apiConfig.get(`${BaseUrl}/payment/verify?paymentId=${paymentId}`);
    dispatch(fetchPaymentVerifySuccess(response.data));
  } catch (error) {
    dispatch(fetchPaymentVerifyFailure(error.message));
  }
};
